export const SET_TEMPLATES = "@@TEMPLATE/SET_TEMPLATES";
